import { z } from 'zod';
import { EngagementTask, EngagementLeaderboardMetric, EngagementSettings, IntegrityReview, PointAccount, PointPoolGroupLink, PointLedgerEntry, PointPool, RewardItem, RewardRedemption, RewardWindow, TaskRule, } from './engagement.js';
export const EngagementSettingsResponse = z.object({
    enabled: z.boolean(),
    pool: PointPool.nullable(),
    poolLink: PointPoolGroupLink.nullable().optional(),
    groupId: z.string().uuid(),
    settings: EngagementSettings,
});
export const EngagementCapabilitiesResponse = z.object({
    enabled: z.boolean(),
    pointsEnabled: z.boolean(),
    rewardsEnabled: z.boolean(),
    integrityReviewEnabled: z.boolean(),
    canManage: z.boolean(),
    canConfigurePool: z.boolean(),
    canManageAllPoolResources: z.boolean(),
    poolId: z.string().uuid().nullable(),
});
export const TaskWithRules = EngagementTask.extend({
    rules: z.array(TaskRule),
});
export const TasksResponse = z.object({ tasks: z.array(TaskWithRules) });
export const TaskResponse = z.object({ task: TaskWithRules });
export const PointLedgerResponse = z.object({
    entries: z.array(PointLedgerEntry),
    total: z.number().int().nonnegative(),
    limit: z.number().int().positive(),
    offset: z.number().int().nonnegative(),
});
export const PointLeaderboardRow = z.object({
    userId: z.string().uuid(),
    displayName: z.string().nullable(),
    balance: z.number().int().nullable(),
    lifetimeEarned: z.number().int().nonnegative().nullable(),
});
export const PointLeaderboardResponse = z.object({
    visible: z.boolean(),
    metric: EngagementLeaderboardMetric,
    showExactPoints: z.boolean(),
    emptyMessage: z.string().nullable(),
    rows: z.array(PointLeaderboardRow),
});
export const MyPointPoolSummary = z.object({
    pool: PointPool,
    account: PointAccount,
    groupIds: z.array(z.string().uuid()),
    groupNames: z.array(z.string()),
});
export const MyPointsResponse = z.object({ pools: z.array(MyPointPoolSummary) });
export const PoolsResponse = z.object({ pools: z.array(MyPointPoolSummary) });
export const PointPoolLinksResponse = z.object({
    links: z.array(PointPoolGroupLink),
});
export const PointPoolLinkResponse = z.object({
    link: PointPoolGroupLink,
    pool: PointPool.nullable().optional(),
});
export const RewardWithWindow = RewardItem.extend({
    window: RewardWindow.nullable(),
});
export const RewardsResponse = z.object({ rewards: z.array(RewardWithWindow) });
export const RewardResponse = z.object({ reward: RewardWithWindow });
export const RedemptionResponse = z.object({ redemption: RewardRedemption });
export const RedemptionsResponse = z.object({
    redemptions: z.array(RewardRedemption),
});
export const IntegrityReviewsResponse = z.object({
    reviews: z.array(IntegrityReview),
});
export const IntegrityReviewResponse = z.object({ review: IntegrityReview });
//# sourceMappingURL=responses.js.map